export default __webpack_public_path__ + "static/media/next_button.069f2f1c.svg";